import { render } from "./CategoriasVoucher.vue?vue&type=template&id=ca842388&scoped=true"
import script from "./CategoriasVoucher.vue?vue&type=script&lang=js"
export * from "./CategoriasVoucher.vue?vue&type=script&lang=js"

import "./CategoriasVoucher.vue?vue&type=style&index=0&id=ca842388&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca842388"]])

export default __exports__